import React from 'react';
import { FaTaxi } from 'react-icons/fa';
import './ImportantNotes.css';

const ImportantNotes = () => {
  const notes = [
    {
      id: 'toll-fees',
      text: 'Toll Fees, Inter-State Permit charges (if any) are extra. Driver bata is Rs. 300/- per day for Round Trip.'
    },
    {
      id: 'drop-trips',
      text: 'Drop Trips - Driver Bata Rs. 400/ - per day for One Way trip.'
    },
    {
      id: 'round-trips',
      text: 'Round Trips - Minimum running must be 250kms per day. For Bengaluru it is minimum 300kms per day.'
    },
    {
      id: 'drop-trips-minimum',
      text: 'Drop Trips - Minimum running must be 130 kms per day.'
    },
    {
      id: 'calendar-day',
      text: '1 day means 1 Calender day (from midnight 12 to Next Midnight 12)'
    },
    {
      id: 'waiting-charges',
      text: 'Waiting Charges will be Rs.2 per min.(Except 30 min for food.)'
    },
    {
      id: 'luggage-capacity',
      text: 'Max lagguage capacity by vehicle type Sedan - 3 suitcases, Suv - 4 suitcases'
    }
  ];

  return (
    <div className="important-notes">
      <div className="notes-container">
        <div className="notes-header">
          <h2 className="notes-title">Note</h2>
        </div>
        
        <div className="notes-list">
          {notes.map((note) => (
            <div key={note.id} className="note-item">
              <FaTaxi className="note-bullet" />
              <p className="note-text">{note.text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ImportantNotes;
